/**
 * Calculates what page on the vehicle SRP we are on based on starting point in total inventory and num vehicles on the page
 * @param {number} pageStart Starting place of first vehicle in total count of inventory
 * @param {number} pageSize Number of vehicles showing per page
 * @returns
 */
export const getPageNumber = (pageStart, pageSize) => {
	return Math.floor(pageStart / pageSize) + 1;
};
